module.exports = __webpack_public_path__ + "img/jori_no_border.5b7475ec.png";